"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfinityIcon = void 0;
var React = __importStar(require("react"));
function InfinityIcon(props) {
  var _a, _b, _c, _d;
  return React.createElement("svg", __assign({
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 24,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#191C22",
    viewBox: (_d = props.viewBox) !== null && _d !== void 0 ? _d : "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M22 12.008c0 1.402-.464 2.585-1.393 3.548-.929.963-2.106 1.444-3.532 1.444-2.046 0-3.754-1.136-5.125-3.407-1.382 2.22-3.035 3.329-4.958 3.329-1.504 0-2.715-.461-3.632-1.382C2.453 14.619 2 13.42 2 11.945c0-1.434.464-2.616 1.393-3.548C4.333 7.466 5.533 7 6.992 7c1.99 0 3.654 1.125 4.991 3.375 1.371-2.208 3.068-3.312 5.092-3.312 1.459 0 2.642.455 3.549 1.366.917.91 1.376 2.103 1.376 3.579ZM7.124 14.834c.697 0 1.344-.225 1.94-.675.598-.46 1.184-1.199 1.759-2.214-.542-.984-1.112-1.711-1.709-2.182a3.138 3.138 0 0 0-2.023-.706c-.851 0-1.542.277-2.073.832-.52.544-.78 1.24-.78 2.088 0 .847.26 1.538.78 2.072.52.523 1.222.785 2.106.785Zm9.752-5.715c-.697 0-1.344.236-1.94.707-.587.46-1.173 1.188-1.759 2.182.542.984 1.112 1.711 1.709 2.182.597.47 1.271.706 2.023.706.84 0 1.526-.272 2.056-.816.53-.544.796-1.235.796-2.072 0-.816-.265-1.502-.796-2.057-.52-.554-1.216-.832-2.09-.832Z"
  }));
}
exports.InfinityIcon = InfinityIcon;